import { Action } from './action-button';
import { TaskCommand } from '@/lib/api/task';

/** Actions available for boxes — shared by the Boxes list and the Task page. */
export const boxActions: Action[] = [
  { label: 'Reboot', value: TaskCommand.Reboot },
  { label: 'Screen capture', value: TaskCommand.ScreenCapture },
  { label: 'Start app', value: TaskCommand.StartApp },
  { label: 'Stop app', value: TaskCommand.StopApp },
  { label: 'Power On', value: TaskCommand.PowerOn },
  { label: 'Power Off', value: TaskCommand.PowerOff },
  { label: 'TV On', value: TaskCommand.TvOn },
  { label: 'TV Off', value: TaskCommand.TvOff },
  { label: 'Check Android Version', value: TaskCommand.CheckAndroidVersion },
  { label: 'Check App Version', value: TaskCommand.CheckAppVersion },
  { label: 'Get logcat', value: TaskCommand.GetLogcat },
];
